import React from 'react';
import PropTypes from 'prop-types';

import GridColumnFlex from '../../GridColumnFlex';
import ImageBase from '../../../atoms/Image';
import { ChildrenPropType } from '../../../services/proptypes';


const propTypes = {
  background: PropTypes.bool,
  children: ChildrenPropType,
  width: PropTypes.string,
};

const defaultProps = {
  background: false,
  children: null,
  width: null,
};

function Image({background, children, width, ...imageProps}) {
  const isBackground = !!(children && children.length) || background;

  if (isBackground) {
    return (
      <ImageBase {...imageProps} background as={GridColumnFlex} width={width}>{children}</ImageBase>
    )
  }

  return (
    <GridColumnFlex className="image-component" width={width}>
      <ImageBase {...imageProps} />
    </GridColumnFlex>
  );
}

Image.propTypes = propTypes;
Image.defaultProps = defaultProps;

export default Image;
